import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {Dialog, DialogContent} from "@mui/material";

import './PicksSubmissionPopUp.style.scss';
import {FormattedMessage} from "react-intl";
const PicksSubmissionPopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options}) => {
    return (
        <Dialog open={open}
                onClose={onClose}
                className="PicksSubmissionPopUp">
            <DialogContent className="picksSubmissionContent">
                <div className={"closeButton"} onClick={onClose}>X</div>
                <Typography className="title gold-gradient-text"><FormattedMessage id={'popUp.picksSubmission.title'}/></Typography>
                <Typography className="subTitle">
                    <FormattedMessage id={'popUp.picksSubmission.subTitle'}/> <span className="myPicksLink"
                                                                                    onClick={() => {
                                                                                        window.location.href = '/myaccount/mypicks/ongoing';
                                                                                    }}><FormattedMessage
                    id={'popUp.picksSubmission.myPicks'}/> </span>
                </Typography>

                <div className={'actionButton'}>
                    <Button className="makeSelectionButton" onClick={() => {
                        onOk();
                    }}>
                        <FormattedMessage id={'popUp.picksSubmission.makeAnotherPick'}/>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default PicksSubmissionPopUp;